module.exports = __webpack_public_path__ + "img/75690.fb326832.svg";